import { type FC } from "react";
import { Spin, SPIN_STATUS } from "../Spin";
import { DotsLoading } from "../Loading";
import { AppImage } from "@components/NextImage";

type SpinMessagePropsType = {
  children: React.ReactNode;
  source?: React.ReactNode;
  reload?: () => void;
  status: { type: SPIN_STATUS; text?: string };
};

const SpinMessage: FC<SpinMessagePropsType> = ({
  children,
  reload = () => {},
  status,
  source,
}) => {
  return (
    <Spin
      reload={reload}
      status={status.type as SPIN_STATUS}
      renderLoading={
        <div className="flex items-center gap-2 py-1">
          <AppImage
            src="/assets/images/chat/thinking_indicator.webp"
            alt="thinking"
            width={24}
            height={24}
            className="flex-shrink-0"
          />
          <div className="body_m text-content_secondary text-gradient-scroll">
            <DotsLoading />
          </div>
        </div>
      }
    >
      {source}
      {children}
    </Spin>
  );
};

export default SpinMessage;
